import React, { useState } from "react";
import "./ParentCommunication.css";
import { FaComments, FaPaperPlane, FaBullhorn } from "react-icons/fa";

const ParentCommunication = () => {
  const [broadcastMessage, setBroadcastMessage] = useState("");
  const [targetClass, setTargetClass] = useState("All");

  const handleSend = (e) => {
    e.preventDefault();
    if (!broadcastMessage.trim()) return;
    alert(`Notice broadcast sent to ${targetClass} parents!`);
    setBroadcastMessage("");
  };

  return (
    <div className="comm-container">
      <div className="comm-header">
        <h2><FaComments /> Parent Broadcast & Announcements</h2>
      </div>

      <div className="comm-card">
        <h3><FaBullhorn /> Send New Broadcast</h3>
        <form onSubmit={handleSend} className="comm-form">
          <div className="form-group">
            <label>Target Class</label>
            <select value={targetClass} onChange={(e) => setTargetClass(e.target.value)}>
              <option value="All">All Classes & Daycare</option>
              <option value="Playgroup">Playgroup</option>
              <option value="Nursery">Nursery</option>
              <option value="LKG">LKG</option>
              <option value="UKG">UKG</option>
            </select>
          </div>

          <div className="form-group">
            <label>Announcement Message</label>
            <textarea
              rows="4"
              placeholder="Write message to send via SMS / App notification..."
              value={broadcastMessage}
              onChange={(e) => setBroadcastMessage(e.target.value)}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn-primary">
            <FaPaperPlane /> Broadcast Announcement
          </button>
        </form>
      </div>
    </div>
  );
};

export default ParentCommunication;